import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LazySettings } from '@mews-commander/modules/src/modules/integrationClient';
import { MewsTeam, RouteType } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';

export const Route = createFileRoute(
    '/_authenticated/$currentEnterpriseId/IntegrationClient/Settings/$integrationClientId'
)({
    validateSearch: z.object({
        type: z.string().optional(),
    }),
    beforeLoad: ({ context: { checkPlatformPrivilege } }) => {
        checkPlatformPrivilege('admin');
    },
    component: Component,
    staticData: {
        title: TextKey.IntegrationClientSettings,
        owner: MewsTeam.ActivationExperience,
        type: RouteType.Frontend,
    },
});

function Component() {
    const { integrationClientId } = Route.useParams();
    const { type } = Route.useSearch();

    return <LazySettings integrationClientId={integrationClientId} type={type} />;
}
